

export const courseConstants = {

    SHOW_COURSES : 'SHOW_COURSES',
    SHOW_QUALIFICATIONS : 'SHOW_QUALIFICATIONS',
    TOGGLE_STUDENT_MULTIPLE_ACTION_LIST: 'TOGGLE_STUDENT_MULTIPLE_ACTION_LIST' ,
    SHOW_COURSE_TEACHERS: 'SHOW_COURSE_TEACHERS',
    SHOW_SUBJECT: 'SHOW_SUBJECT',
    STUDENT_ENROLED: 'STUDENT_ENROLED',
    STUDENT_UNENROLED: 'STUDENT_UNENROLED',
    SHOW_COURSE_SUBJECTS: 'SHOW_COURSE_SUBJECTS',

    UNSCHEDULE_CLASS: 'UNSCHEDULE_CLASS',
    TEACHER_ENROLED: 'TEACHER_ENROLED',
    TEACHER_UNENROLED: 'TEACHER_UNENROLED',

    TUTOR_UNENROLED: 'TUTOR_UNENROLED',
    TUTOR_ENROLED: 'TUTOR_ENROLED',

    SHOW_COURSE_EVALUATIONS: 'SHOW_COURSE_EVALUATIONS'
};